__turbopack_context__.v({
  "card": "Projects-module__lSSj0a__card",
  "cta": "Projects-module__lSSj0a__cta",
  "project": "Projects-module__lSSj0a__project",
  "projectCopy": "Projects-module__lSSj0a__projectCopy",
  "projectCta": "Projects-module__lSSj0a__projectCta",
  "projectCtaRow": "Projects-module__lSSj0a__projectCtaRow",
  "projectHeader": "Projects-module__lSSj0a__projectHeader",
  "projectImg": "Projects-module__lSSj0a__projectImg",
  "projects": "Projects-module__lSSj0a__projects",
  "scroll": "Projects-module__lSSj0a__scroll",
});
